import Icon from '@/components/ui/AppIcon';

const stats = [
  {
    id: 'stat_years',
    number: '4+',
    label: 'Years Experience',
    icon: 'ClockIcon' as const,
  },
  {
    id: 'stat_shoots',
    number: '100+',
    label: 'Successful Shoots',
    icon: 'CameraIcon' as const,
  },
  {
    id: 'stat_clients',
    number: '20+',
    label: 'Happy Clients',
    icon: 'UserGroupIcon' as const,
  },
  {
    id: 'stat_rating',
    number: '5.0',
    label: 'Client Rating',
    icon: 'StarIcon' as const,
  },
];

const credentials = [
  {
    id: 'cred_1',
    title: 'Featured Photographer',
    organization: 'McLaren PHL',
    year: '2025',
  },
  {
    id: 'cred_2',
    title: 'Media Team',
    organization: 'Bimmers vs the World',
    year: '2025',
  },
  // {
  //   id: 'cred_3',
  //   title: 'Workshop Instructor',
  //   organization: 'Photography Institute Delaware',
  //   year: '2023-Present',
  // },
  // {
  //   id: 'cred_4',
  //   title: 'Award Winner',
  //   organization: 'Best Wedding Photography Newark',
  //   year: '2025',
  // },
];

export default function ExperienceSection() {
  return (
    <section className="py-16 space-y-16">
      {/* Stats Grid */}
      <div className="reveal">
        <h3 className="text-3xl font-bold text-white mb-8">Experience</h3>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat) => (
            <div
              key={stat.id}
              className="glass-panel rounded-2xl p-6 text-center space-y-4 hover:bg-card transition-all duration-500"
            >
              <div className="w-12 h-12 mx-auto rounded-lg bg-white/10 flex items-center justify-center">
                <Icon name={stat.icon} size={24} className="text-white" />
              </div>
              <div>
                <p className="text-4xl font-bold text-white mb-1">{stat.number}</p>
                <p className="text-sm text-muted-foreground">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Credentials */}
      <div className="reveal delay-200">
        <h3 className="text-3xl font-bold text-white mb-8">Credentials & Recognition</h3>
        <div className="space-y-4">
          {credentials.map((cred) => (
            <div
              key={cred.id}
              className="glass-panel rounded-xl p-6 hover:bg-card transition-all duration-500"
            >
              <div className="flex items-start justify-between gap-4">
                <div>
                  <h4 className="text-lg font-semibold text-white mb-1">{cred.title}</h4>
                  <p className="text-sm text-muted-foreground">{cred.organization}</p>
                </div>
                <span className="text-sm font-medium text-muted px-3 py-1 glass-panel rounded-full">
                  {cred.year}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
